import {
  SET_FIND_BUSINESS_RESULTS,
  CLEAR_FIND_BUSINESS_RESULTS,
  SET_CREDIT_MAP_RESULTS,
  CLEAR_CREDIT_MAP_RESULTS,
} from "../taskActions";

const initialState = {
  findBusiness: null,
  creditMap: null,
};

const resultsCacheReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FIND_BUSINESS_RESULTS:
      return {
        ...state,
        findBusiness: action.payload,
      };
    case CLEAR_FIND_BUSINESS_RESULTS:
      return {
        ...state,
        findBusiness: null,
      };
    case SET_CREDIT_MAP_RESULTS:
      return {
        ...state,
        creditMap: action.payload,
      };
    case CLEAR_CREDIT_MAP_RESULTS:
      return {
        ...state,
        creditMap: null,
      };
    default:
      return state;
  }
};

export default resultsCacheReducer;
